import * as types from "./actionTypes";

export const notificationRequest = (candidateRef) => ({
  type: types.NOTIFICATIONS_LOAD_REQUEST,
  payload: candidateRef,
});

export const notificationSuccess = (result) => ({
  type: types.NOTIFICATIONS_LOAD_SUCCESS,
  payload: result,
});

export const notificationError = (err) => ({
  type: types.NOTIFICATIONS_LOAD_ERROR,
  payload: err,
});

export const notificationLastReadRequest = (candidateRef) => ({
  type: types.NOTIFICATIONS_LAST_READ_REQUEST,
  payload: candidateRef,
});

export const notificationLastReadSuccess = (result) => ({
  type: types.NOTIFICATIONS_LAST_READ_SUCCESS,
  payload: result,
});

export const notificationLastReadError = (err) => ({
  type: types.NOTIFICATIONS_LAST_READ_ERROR,
  payload: err,
});

export const notificationReadUpdateRequest = (candidateRef) => ({
  type: types.NOTIFICATIONS_READ_UPDATE_REQUEST,
  payload: candidateRef,
});

export const notificationReadUpdateSuccess = (result) => ({
  type: types.NOTIFICATIONS_READ_UPDATE_SUCCESS,
  payload: result,
});

export const notificationReadUpdateError = (err) => ({
  type: types.NOTIFICATIONS_READ_UPDATE_ERROR,
  payload: err,
});
